<div class="max-w-none flex flex-col items-center space-y-[1vh] pt-[3vh]">
    <h1 class="!text-tertiary-50">Welcome to</h1>

    <img
        src="assets/svg/cevo-go-hero.svg"
        alt="Cevo Go Logo"
        class="hero-image"
    />

    <div>
        <p class="text-tertiary-200 !mb-0">Powered by:</p>
        <p class="text-tertiary-200">Enterprise Wireless Alliance</p>
    </div>

    <p class="text-tertiary-50">Less than one minute to submit your request.</p>

    <p class="text-tertiary-50">
        Simple, all-inclusive pricing at industry low rates.
    </p>

    <p class="text-tertiary-50">
        Secure your certified frequencies today, in three easy steps.
    </p>
</div>
